/* Disabled fields for phase 1 */
import React, { useState, useContext } from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CardWrap from "../Common/CardWrap";
import ResultModal from "../Common/ResultModal";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { AuthContext } from "../../Contexts/AuthContext";
import SpinnerLoading from "../Common/SpinnerLoading";
import NumberFormat from "react-number-format";
import {
  itemServices,
  globalServices,
  posServices,
  storeService,
} from "../../Services";
import Tooltip from "../Common/Tooltip";
import { convertToDecimalString } from "../../Helpers/DecimalNumberHelper";
import { roles } from "../../Config/Roles";
import NullTaxRateModal from "./NullTaxRateModal";
import {
  knToEuroConverter,
  euroToKnConverter,
} from "../../Helpers/CurrencyConverter";
import { currencyPriceList, currencyTagSessionName } from "../../Config/Consts";
import { validKpd } from "../../Config/Consts";

const initState = {
  createInAllPriceLists: false,
  name: "",
  code: "",
  barCode: "",
  description: "",
  isService: false,
  pn: null,
  unitOfMeasureId: -1,
  taxRateId: -1,
  itemId: -1,
  price: null,
  pp: null,
  itemGroupId: -1,
  isPriceLocked: false,
};

const normativeTypes = [
  { id: 1, name: "Proizvod" },
  { id: 2, name: "Izvedeni proizvod" },
  { id: 3, name: "Složeni proizvod" },
  { id: 4, name: "Usluga" },
  { id: 5, name: "Prolazna stavka" },
  { id: 6, name: "Subvencija" },
];

const EditItem = ({ match }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { locName, locTenant, locStore, locPos } = useContext(GlobalContext);
  const { roleId } = useContext(AuthContext);
  const { cashier, manager, accountant } = roles;
  const priceListId = match.params.priceListId;
  const itemId = match.params.itemId;
  const currencyTag = sessionStorage.getItem(currencyTagSessionName);

  const history = useHistory();
  const { t: translator } = useTranslation();

  const { register, handleSubmit, errors, control, setValue } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const [item, setItem] = useState({ ...initState, currencyTag: currencyTag });

  const [taxRates, setTaxRates] = useState([]);
  const [unitOfMeasures, setUnitOfMeasures] = useState([]);
  const [itemGroups, setItemGroups] = useState([]);

  const [showNullTaxRate, setShowNullTaxRate] = useState(false);
  const [tenantTaxObligation, setTenantTaxObligation] = useState(false);
  const [resultModal, setResultModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });

  React.useEffect(() => {
    if (locPos != 0) {
      posServices
        .getById(locPos)
        .then((res) => {
          setTenantTaxObligation(res.data.tenantTaxObligation);
        })
        .catch((err) => setTenantTaxObligation(false));
    } else {
      storeService
        .getById(locStore)
        .then((res) => setTenantTaxObligation(res.data.tenantTaxObligation))
        .catch((err) => setTenantTaxObligation(false));
    }

    if ([cashier, manager, accountant].includes(Number(roleId)))
      history.push("/error-page/401");
    globalServices.getTaxRates().then((res) => setTaxRates(res.data));

    globalServices
      .getUnitOfMeasures()
      .then((res) => setUnitOfMeasures(res.data));

    globalServices.getItemGroups(Number(locTenant)).then((res) => {
      setItemGroups(res.data);
    });

    if (itemId) {
      setIsLoading(true);
      itemServices
        .getById(priceListId, itemId)
        .then((data) => {
          setItem({
            itemId: data.data.itemId,
            priceListItemId: data.data.priceListItemId,
            name: data.data.name,
            barCode: data.data.barCode,
            code: data.data.code,
            description: data.data.description,
            isService: data.data.isService,
            itemGroupId: data.data.itemGroupId,
            pn: data.data.pn,
            pp: data.data.pp,
            price: data.data.price,
            currencyTag: data.data.currencyTag,
            taxRateId: data.data.taxRateId,
            unitOfMeasureId: data.data.unitOfMeasureId,
            isPriceLocked: false,
            currencyId: data.data.currencyId,
            normativeTypeId: data.data.normativeTypeId,
            isFavorite: data.data.isFavorite,
            classNumber: data.data.classNumber,
            inMode: data.data.inMode,
            image: data.data.image,
            taxExemptionReason: data.data.taxExemptionReason,
          });
          setImage(data.data.image);
          setIsLoading(false);
        })
        .catch((err) => console.log("error", err));
    }
  }, []);

  const checkPrice = () => {
    if (document.getElementsByName("isRawMaterial")[0].checked) {
      return true;
    }
    return document.getElementById("priceInput").value != "";
  };

  const handleIsServiceChange = (event) => {
    setItem({ ...item, isService: !item.isService });
  };

  const handleCloseResultModal = () => {
    setResultModal({ show: false, warningText: null });
    if (resultModal.success === true) {
      if (item.normativeTypeId == 2 || item.normativeTypeId == 3)
        history.push(`/item-details/${priceListId}/${item.itemId}`);
      else goBack();
    }
  };

  const onSubmit = (data) => {
    //alert(data.isFavorite)
    if (itemId) {
      itemServices
        .update({
          itemId: itemId,
          priceListId: priceListId && Number(priceListId),
          name: data.name,
          code: data.code,
          barCode: data.barCode,
          description: data.description,
          isService: false,
          pn: data.pnInput
            ? parseFloat(convertToDecimalString(data.pnInput))
            : null,
          unitOfMeasureId: Number(data.unitOfMeasureId),
          taxRateId:
            Number(data.taxRateId) == -1 ? null : Number(data.taxRateId),
          changePriceByTaxRate: false,
          itemGroupId: Number(data.itemGroupId) == -1 ? null : data.itemGroupId,
          priceListItemId: item.priceListItemId,
          price: parseFloat(convertToDecimalString(data.priceInput)),
          pp: parseFloat(data.pp),
          isPriceLocked: false,
          isRawMaterial: item.isRawMaterial ?? false,
          normativeTypeId:
            Number(data.normativeTypeId) == -1
              ? 1
              : Number(data.normativeTypeId),
          isFavorite: data.isFavorite ?? false,
          classNumber: data.classNumber ?? "",
          inMode: data.inMode ?? false,
          image:image,
          taxExemptionReason: data.taxExemptionReason ?? "",
        })
        .then((res) => {
          res.data.success
            ? setResultModal({
                show: true,
                title: translator("EditItem-UpdateItem-SuccesModal-Title"),
                text: translator("EditItem-UpdateItem-SuccesModal-Text"),
                warningText:
                  item.isPriceLocked &&
                  item.currencyTag === currencyPriceList.kn &&
                  translator("EditItem-UpdateItem-SuccessModal-WarningText"),
                btnClass: "btn btn-primary",
                success: true,
              })
            : setResultModal({
                show: true,
                title: translator("EditItem-Update-UnsuccessModal-Title"),
                text: res.data.message,
                btnClass: "btn btn-primary",
                success: false,
              });
        })
        .catch((err) => {
          console.log("err", err);
          setResultModal({
            show: true,
            title: translator("EditItem-Update-UnsuccessModal-Title"),
            text: err.data,
            btnClass: "btn btn-primary",
            success: false,
          });
        });
    } else {
      itemServices
        .create({
          tenantId: locTenant && Number(locTenant),
          createInAllPriceLists: true,
          priceListId: priceListId && Number(priceListId),
          name: data.name,
          code: data.code,
          barCode: data.barCode,
          description: data.description,
          isService: false,
          pn: data.pnInput
            ? parseFloat(convertToDecimalString(data.pnInput))
            : null,
          unitOfMeasureId: Number(data.unitOfMeasureId),
          taxRateId:
            Number(data.taxRateId) == -1 ? null : Number(data.taxRateId),
          itemGroupId: Number(data.itemGroupId) == -1 ? null : data.itemGroupId,
          price: parseFloat(convertToDecimalString(data.priceInput)),
          pp: Number(data.pp),
          isPriceLocked: false,
          currencyId: currencyPriceList[currencyTag],
          isRawMaterial: item.isRawMaterial ?? false,
          normativeTypeId:
            Number(data.normativeTypeId) == -1
              ? 1
              : Number(data.normativeTypeId),
          isFavorite: data.isFavorite ?? false,
          classNumber: data.classNumber ?? "",
          inMode: data.inMode ?? false,
          image:image,
          taxExemptionReason: data.taxExemptionReason ?? "",
        })
        .then((res) => {
          console.log("res", res);
          res.data.success
            ? setResultModal({
                show: true,
                title: translator("EditItem-AddNewItem-SuccesModal-Title"),
                text: translator("EditItem-AddNewItem-SuccesModal-Text"),
                btnClass: "btn btn-primary",
                success: true,
              })
            : setResultModal({
                show: true,
                title: translator("EditItem-Add-UnsuccessModal-Title"),
                text: res.data.message,
                btnClass: "btn btn-primary",
                success: false,
              });
        })
        .catch((err) =>
          setResultModal({
            show: true,
            title: translator("EditItem-Add-UnsuccessModal-Title"),
            text: err.data.message,
            btnClass: "btn btn-primary",
            success: false,
          }),
        );
    }
  };

  const [image, setImage] = useState(null);

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setImage(reader.result); // data:image/...;base64,
    };
    reader.readAsDataURL(file);
  };

  const handleCancel = (e) => {
    e.preventDefault();
    goBack();
  };

  const goBack = () => {
    switch (locName) {
      case "stores":
        history.push(`/${locName}/${locStore}`);
        break;
      case "pos":
        history.push(`/${locName}/${locPos}`);
        break;
      default:
        history.push("/error");
    }
  };

  const currencyConverter = (currencyTag, value) => {
    return currencyTag === currencyPriceList.euro
      ? euroToKnConverter(value)
      : knToEuroConverter(value);
  };
  const handleChangeRawMaterial = () => {
    if (item.isService) {
      setItem({
        ...item,
        isService: false,
        isRawMaterial: !item.isRawMaterial,
      });
    } else setItem({ ...item, isRawMaterial: !item.isRawMaterial });
  };

  const handleChangeIsFavorite = () => {
    setItem({ ...item, isFavorite: !item.isFavorite });
  };
  const handleChangeInMode = () => {
    setItem({ ...item, inMode: !item.inMode });
  };

  const handleChangeNormativeType = (event) => {
    setItem({ ...item, normativeTypeId: Number(event.target.value) });
  };

  const isPassThroughOrSubvention =
    item.normativeTypeId === 5 || item.normativeTypeId === 6;

  return (
    <CardWrap
      title={translator("EditItem-Title-ItemManagement")}
      subtitle={
        itemId
          ? translator("EditItem-Subtitle-UpdateArticle")
          : translator("EditItem-Subtitle-NewArticle")
      }
    >
      {tenantTaxObligation == false ? (
        <div
          style={{ margin: 5, marginBottom: "20px" }}
          className="alert alert-warning"
          role="alert"
        >
          {translator("Tenant-FiscalObligation")}
        </div>
      ) : (
        ""
      )}
      <div
        style={{ margin: 5, marginBottom: "20px" }}
        className="alert alert-warning"
        role="alert"
      >
        {translator("Tenant-EdiItem-Warning")}
      </div>

      {isLoading && <SpinnerLoading />}
      {!isLoading && (
        <form onSubmit={handleSubmit(onSubmit)} className="row">
          <div className="col-lg-4">
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">
                {translator("EditItem-ArticleData")}
              </legend>
              <div className="form-group">
                <label className="labelCont">
                  <input
                    type="checkbox"
                    name="isRawMaterial"
                    defaultChecked={item.isRawMaterial}
                    onChange={handleChangeRawMaterial}
                  />
                  <span className="checkmark"></span>
                </label>
                <span>{translator("EditItem-RawMaterial")}</span>{" "}
              </div>
              <div className="form-group">
                <label htmlFor="ddlType">{translator("Tip proizvoda")}</label>{" "}
                <Tooltip text={translator("Item-UnitOfMeasure-Msg")} />
                <select
                  name="normativeTypeId"
                  ref={register({
                    validate: (value) => item.isRawMaterial || value !== "-1",
                  })}
                  className="form-control"
                  disabled={item.isRawMaterial}
                  onChange={handleChangeNormativeType}
                >
                  <option value="-1">{translator("EditItem-Choose")}</option>
                  {normativeTypes.map((x) => (
                    <option
                      selected={item.normativeTypeId === x.id}
                      value={x.id}
                      key={x.id}
                    >
                      {x.name}
                    </option>
                  ))}
                </select>
                {errors.normativeTypeId &&
                  errors.normativeTypeId.type === "validate" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
              </div>
              <div className="form-group">
                <label>{translator("EditItem-Name")}</label>{" "}
                <Tooltip text={translator("Item-Name-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  ref={register({ required: true, maxLength: 100 })}
                  defaultValue={item.name}
                />
                {errors.name && errors.name.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
                {errors.name && errors.name.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength100")}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label htmlFor="ddlStore">
                  {translator("EditItem-ItemGroup")}
                </label>
                <select
                  name="itemGroupId"
                  ref={register({
                    validate: (value) => item.isRawMaterial || value !== "-1",
                  })}
                  className="form-control"
                >
                  <option value="-1">{translator("EditItem-Choose")}</option>
                  {itemGroups &&
                    itemGroups.map((g) => (
                      <option
                        key={g.id}
                        selected={item.itemGroupId === g.id}
                        value={g.id}
                      >
                        {g.name}
                      </option>
                    ))}
                </select>
                {errors.itemGroupId &&
                  errors.itemGroupId.type === "validate" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
              </div>
              <div className="form-group">
                <label htmlFor="ddlStore">
                  {translator("EditItem-UnitOfMeasure")}
                </label>{" "}
                <Tooltip text={translator("Item-UnitOfMeasure-Msg")} />
                <select
                  name="unitOfMeasureId"
                  ref={register({
                    validate: (value) => value !== "-1",
                  })}
                  className="form-control"
                >
                  <option value="-1">{translator("EditItem-Choose")}</option>
                  {unitOfMeasures &&
                    unitOfMeasures.map((x) => (
                      <option
                        selected={item.unitOfMeasureId === x.id}
                        value={x.id}
                        key={x.id}
                      >
                        {x.name + "->" + x.code}
                      </option>
                    ))}
                </select>
                {errors.unitOfMeasureId &&
                  errors.unitOfMeasureId.type === "validate" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
              </div>
            </fieldset>
          </div>
          <div className="col-lg-4">
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">
                {translator("EditItem-TaxInformation")}
              </legend>
              <div className="form-group">
                <strong>
                  {" "}
                  <label>{translator("EditItem-Price")}</label>{" "}
                  <Tooltip text={translator("Item-Price-Msg")} />
                </strong>
                <div className="input-group">
                  <Controller
                    name="priceInput"
                    control={control}
                    rules={{
                      validate: checkPrice,
                      maxLength: 14,
                    }}
                    as={
                      <NumberFormat
                        id="priceInput"
                        onValueChange={(e) => {
                          const value = e.floatValue;
                          setValue(
                            "priceInput2",
                            currencyConverter(item.currencyTag, value),
                          );
                        }}
                        allowNegative={false}
                        thousandSeparator={" "}
                        decimalSeparator={","}
                        fixedDecimalScale={true}
                        decimalScale={2}
                        placeholder={"0,00"}
                        inputMode="numeric"
                        className="form-control"
                        disabled={Boolean(item.isRawMaterial)}
                      />
                    }
                    defaultValue={item.price}
                  />
                  <div className="input-group-append">
                    <span className="input-group-text" id="basic-addon2">
                      {item.currencyTag === currencyPriceList.euro ? "€" : "KN"}
                    </span>
                  </div>
                </div>
                {errors.priceInput && errors.priceInput.type === "validate" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
                {errors.priceInput &&
                  errors.priceInput.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-PriceInput")}
                    </p>
                  )}
              </div>
              {/* <div className="form-group">
                <div className="input-group">
                  <Controller
                    name="priceInput2"
                    control={control}
                    defaultValue={currencyConverter(
                      item.currencyTag,
                      item.price
                    )}
                    as={
                      <NumberFormat
                        id="priceInput2"
                        thousandSeparator={" "}
                        decimalSeparator={","}
                        fixedDecimalScale={true}
                        decimalScale={2}
                        inputMode="numeric"
                        className="form-control"
                        disabled={true}
                      />
                    }
                  />
                  <div className="input-group-append">
                    <span className="input-group-text" id="basic-addon2">
                      {item.currencyTag === currencyPriceList.euro ? "KN" : "€"}
                    </span>
                  </div>
                </div>
              </div> */}
              <div className="form-group">
                <label htmlFor="ddlStore">
                  {translator("EditItem-TaxRate")}
                </label>{" "}
                <Tooltip text={translator("Item-TaxRate-Msg")} />
                <select
                  ref={register}
                  name="taxRateId"
                  onChange={(e) => {
                    if (e.target.value == 0) {
                      setShowNullTaxRate(true);
                    } else {
                      setShowNullTaxRate(false);
                    }
                  }}
                  className="form-control"
                  disabled={
                    tenantTaxObligation == false ||
                    //Boolean(itemId) ||
                    Boolean(item.isRawMaterial) ||
                    isPassThroughOrSubvention
                  }
                >
                  <option value="-1">{translator("EditItem-Choose")}</option>
                  <option value={0}>{translator("NullTaxRate")}</option>
                  {taxRates &&
                    taxRates.map((x) => (
                      <option selected={item.taxRateId === x.id} value={x.id}>
                        {x.name}
                      </option>
                    ))}
                </select>
                {errors.taxRateId && errors.taxRateId.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
              </div>

              <div className="form-group">
                <label>{translator("EditItem-Refunds")}</label>{" "}
                <Tooltip text={translator("Item-Refunds-Msg")} />
                <div className="input-group">
                  <Controller
                    name="pnInput"
                    control={control}
                    rules={{
                      validate: function (value) {
                        //alert(value);
                        if (
                          value === "" ||
                          value == null ||
                          value === "0,00" ||
                          value === 0 ||
                          value === "0,10" ||
                          value == 0.1
                        ) {
                          //alert(value);
                          return true;
                        } else return false;
                      },
                    }}
                    as={
                      <NumberFormat
                        thousandSeparator={" "}
                        decimalSeparator={","}
                        fixedDecimalScale={true}
                        decimalScale={2}
                        placeholder={"0,00"}
                        inputMode="numeric"
                        className="form-control"
                        disabled={
                          Boolean(item.isRawMaterial) ||
                          isPassThroughOrSubvention
                        }
                      />
                    }
                    defaultValue={item.pn}
                  />
                  <div className="input-group-append">
                    <span className="input-group-text" id="basic-addon2">
                      EUR
                    </span>
                  </div>
                </div>
                {errors.pnInput && errors.pnInput.type === "validate" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-PN")}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label>{translator("EditItem-ConsummationTax")}</label>{" "}
                <Tooltip text={translator("Item-ConsummationTax-Msg")} />
                <div className="input-group">
                  <input
                    type="number"
                    min="0"
                    step=".01"
                    className="form-control"
                    name="pp"
                    ref={register({
                      required:
                        !Boolean(item.isRawMaterial) &&
                        !isPassThroughOrSubvention,
                      min: 0,
                      max: 3,
                    })}
                    defaultValue={item.pp}
                    disabled={
                      Boolean(item.isRawMaterial) || isPassThroughOrSubvention
                    }
                  />
                  <div className="input-group-append">
                    <span className="input-group-text" id="basic-addon2">
                      %
                    </span>
                  </div>
                </div>
                {errors.pp && errors.pp.type === "required" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-RequiredField")}
                  </p>
                )}
                {errors.pp &&
                  (errors.pp.type === "min" || errors.pp.type === "max") && (
                    <p className="text-danger">
                      {translator("ValidationMsg-PP")}
                    </p>
                  )}
              </div>
              <div className="form-group">
                <label className="labelCont">
                  <input
                    type="checkbox"
                    name="isFavorite"
                    ref={register}
                    defaultChecked={item.isFavorite}
                    onChange={handleChangeIsFavorite}
                  />
                  <span className="checkmark"></span>
                </label>
                <span>{translator("EditItem-Favorit")}</span>{" "}
              </div>
            </fieldset>
          </div>
          <div className="col-lg-4">
            <fieldset className="scheduler-border">
              <legend className="scheduler-border">
                {translator("EditItem-OtherData")}
              </legend>

              <div className="form-group">
                <label>{translator("EditItem-Code")}</label>{" "}
                <Tooltip text={translator("Item-Code-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  name="code"
                  defaultValue={item.code}
                  ref={register({
                    maxLength: 10,
                  })}
                />
                {errors.code && errors.code.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength10")}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label>{translator("EditItem-BarCode")}</label>{" "}
                <Tooltip text={translator("Item-BarCode-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  name="barCode"
                  defaultValue={item.barCode}
                  ref={register({ maxLength: 15 })}
                />
                {errors.barCode && errors.barCode.type === "maxLength" && (
                  <p className="text-danger">
                    {translator("ValidationMsg-MaxLength15")}
                  </p>
                )}
              </div>
              <div className="form-group">
                <label>{translator("EditItem-Description")}</label>{" "}
                <Tooltip text={translator("Item-Description-Msg")} />
                <textarea
                  style={{ height: "64px" }}
                  id="textArea"
                  className="form-control"
                  name="description"
                  defaultValue={item.description}
                  ref={register({
                    maxLength: 250,
                  })}
                />
                {errors.description &&
                  errors.description.type === "maxLength" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-MaxLength250")}
                    </p>
                  )}
              </div>
              <div className="form-group">
                <label>{translator("EditItem-ClassNumber")}</label>{" "}
                <Tooltip text={translator("Item-ClassNumber-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  name="classNumber"
                  defaultValue={item.classNumber}
                  ref={register({
                    validate: (value) => {
                      // Ako je polje prazno, preskoči validaciju
                      if (!value) return true;

                      // Ako polje nije prazno, provjeri listu
                      return (
                        validKpd.includes(value) || "Svaki artikl MORA imati identifikator klasifikacije artikla iz sheme Klasifikacija proizvoda po djelatnostima. Ovaj se ne nalazi na listi."
                      );
                    },
                  })}
                />
                {errors.classNumber && (
                  <p style={{ color: "red" }}>{errors.classNumber.message}</p>
                )}
              </div>
              <div className="form-group">
                <label>{translator("EditItem-TaxExemptionReason")}</label>{" "}
                <Tooltip text={translator("Item-TaxExemptionReason-Msg")} />
                <input
                  type="text"
                  className="form-control"
                  name="taxExemptionReason"
                  defaultValue={item.taxExemptionReason}
                  ref={register({
                    required: isPassThroughOrSubvention,
                    maxLength: 255,
                  })}
                />
                {errors.taxExemptionReason &&
                  errors.taxExemptionReason.type === "required" && (
                    <p className="text-danger">
                      {translator("ValidationMsg-RequiredField")}
                    </p>
                  )}
                {errors.taxExemptionReason &&
                  errors.taxExemptionReason.type === "maxLength" && (
                    <p className="text-danger">
                      {errors.taxExemptionReason.message}
                    </p>
                  )}
              </div>
              <div className="form-group">
                <label className="labelCont">
                  <input
                    type="checkbox"
                    name="inMode"
                    ref={register}
                    defaultChecked={item.inMode}
                    onChange={handleChangeInMode}
                  />
                  <span className="checkmark"></span>
                </label>
                <span>{translator("EditItem-EasyMode")}</span>{" "}
              </div>
              {item &&
                item.inMode && (
                  <div className="form-group">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleChange}
                      name="image"
                    />
                    {image && <img src={image} alt="Preview" width={200} />}
                  </div>
                )}
            </fieldset>
          </div>

          <div
            className="container-fluid"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={handleCancel}
            >
              {translator("Btn-Cancel")}
            </button>
            &nbsp;
            <button className="btn btn-primary" type="submit">
              {translator("Btn-Save")}
            </button>
          </div>
        </form>
      )}
      <ResultModal
        show={resultModal.show}
        title={resultModal.title}
        text={resultModal.text}
        warningText={resultModal.warningText}
        btnClass={resultModal.btnClass}
        handleClose={handleCloseResultModal}
      />
      <NullTaxRateModal
        show={showNullTaxRate}
        handleHide={() => {
          setShowNullTaxRate(false);
        }}
        title={translator("NullTaxRate")}
        text={translator("NullTaxRate-TextModal")}
      />
    </CardWrap>
  );
};

export default EditItem;
